import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="w-full bg-[#0a1220] text-gray-500 py-8 px-6 border-t border-gray-800/50" data-id="element-36">
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-6 text-sm" data-id="element-37">
          <span data-id="element-38">© {new Date().getFullYear()} UGC Starter Kit</span>
          <span className="hidden sm:block text-gray-700" data-id="element-39">·</span>
          <button onClick={() => setActiveModal('privacy')} className="text-gray-500 hover:text-[#E8722A] transition-colors underline underline-offset-2" data-id="element-40">
            Privacy Policy
          </button>
          <span className="hidden sm:block text-gray-700" data-id="element-41">·</span>
          <button onClick={() => setActiveModal('terms')} className="text-gray-500 hover:text-[#E8722A] transition-colors underline underline-offset-2" data-id="element-42">
            Terms of Service
          </button>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Privacy Policy" data-id="element-43">
        <p className="text-gray-400 italic" data-id="element-44">Last updated: February 2026</p>

        <h3 className="text-white font-semibold text-base mt-4" data-id="element-45">
          1. Information We Collect
        </h3>
        <p data-id="element-46">
          When you purchase the UGC Starter Kit, we collect the information
          necessary to process your transaction, including your name, email
          address, and payment details. Payment processing is handled by our
          secure third-party payment provider — we do not store your full credit
          card information.
        </p>

        <h3 className="text-white font-semibold text-base mt-4" data-id="element-47">
          2. How We Use Your Information
        </h3>
        <p data-id="element-48">
          We use your information solely to deliver your digital product, send
          purchase confirmations, and provide customer support. We do not sell,
          rent, or share your personal information with third parties for
          marketing purposes.
        </p>

        <h3 className="text-white font-semibold text-base mt-4" data-id="element-49">
          3. Digital Product Delivery
        </h3>
        <p data-id="element-50">
          Upon purchase, you will receive immediate access to the UGC Starter
          Kit via digital download. Your email address is used to deliver the
          product and any related updates.
        </p>

        <h3 className="text-white font-semibold text-base mt-4" data-id="element-51">
          4. Cookies & Analytics
        </h3>
        <p data-id="element-52">
          We may use basic analytics tools to understand how visitors interact
          with our sales page. These tools may use cookies to collect anonymous
          usage data. You can disable cookies in your browser settings at any
          time.
        </p>

        <h3 className="text-white font-semibold text-base mt-4" data-id="element-53">
          5. Data Security
        </h3>
        <p data-id="element-54">
          We take reasonable measures to protect your personal information. All
          transactions are encrypted using SSL technology. However, no method of
          transmission over the internet is 100% secure.
        </p>

        <h3 className="text-white font-semibold text-base mt-4" data-id="element-55">
          6. Your Rights
        </h3>
        <p data-id="element-56">
          You may request access to, correction of, or deletion of your personal
          data at any time by contacting us. We will respond to your request
          within a reasonable timeframe.
        </p>

        <h3 className="text-white font-semibold text-base mt-4" data-id="element-57">
          7. Changes to This Policy
        </h3>
        <p data-id="element-58">
          We may update this Privacy Policy from time to time. Any changes will
          be reflected on this page with an updated revision date.
        </p>
      </LegalModal>

      {/* Terms of Service Modal */}
      <LegalModal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Terms of Service" data-id="element-59">
        <p className="text-gray-400 italic" data-id="element-60">Last updated: February 2026</p>

        <h3 className="text-white font-semibold text-base mt-4" data-id="element-61">
          1. Product Description
        </h3>
        <p data-id="element-62">
          The UGC Starter Kit is a digital workbook and resource pack designed
          to help beginners create user-generated content (UGC) and pitch brands
          for paid collaborations. It is delivered as an instant digital
          download upon purchase.
        </p>

        <h3 className="text-white font-semibold text-base mt-4" data-id="element-63">
          2. Digital Product — No Refunds
        </h3>
        <p data-id="element-64">
          Due to the digital nature of this product, all sales are final. Once
          the product has been delivered and downloaded, refunds are not
          available. By completing your purchase, you acknowledge and agree to
          this policy.
        </p>

        <h3 className="text-white font-semibold text-base mt-4" data-id="element-65">
          3. Intellectual Property
        </h3>
        <p data-id="element-66">
          All content within the UGC Starter Kit — including text, templates,
          scripts, and design assets — is the intellectual property of Creator
          Sanreiita. You are granted a personal, non-transferable license to use
          the materials for your own business purposes. You may not resell,
          redistribute, or share the kit or its contents.
        </p>

        <h3 className="text-white font-semibold text-base mt-4" data-id="element-67">
          4. Earnings Disclaimer
        </h3>
        <p data-id="element-68">
          The UGC Starter Kit provides education and tools. Results depend on
          individual effort, skill development, and market conditions. We do not
          guarantee any specific income or results. Any examples of earnings or
          outcomes are illustrative and not promises of typical results.
        </p>

        <h3 className="text-white font-semibold text-base mt-4" data-id="element-69">
          5. Use of Materials
        </h3>
        <p data-id="element-70">
          You agree to use the kit's materials responsibly and ethically. The
          scripts and templates provided are starting points — you are
          responsible for customizing them and ensuring your outreach and
          content comply with applicable laws and platform guidelines.
        </p>

        <h3 className="text-white font-semibold text-base mt-4" data-id="element-71">
          6. Limitation of Liability
        </h3>
        <p data-id="element-72">
          To the fullest extent permitted by law, we shall not be liable for any
          indirect, incidental, or consequential damages arising from your use
          of the UGC Starter Kit. Our total liability shall not exceed the
          purchase price of the product.
        </p>

        <h3 className="text-white font-semibold text-base mt-4" data-id="element-73">
          7. Changes to Terms
        </h3>
        <p data-id="element-74">
          We reserve the right to update these Terms of Service at any time.
          Continued use of the product after changes constitutes acceptance of
          the updated terms.
        </p>
      </LegalModal>
    </>;
}